/**
 * 用戶相關工具函數
 */

/**
 * 獲取當前用戶信息
 * @returns {Object} 用戶信息對象
 */
export const getUserInfo = () => {
  try {
    return JSON.parse(localStorage.getItem('userInfo') || '{}');
  } catch (e) {
    console.error('解析 userInfo 失敗:', e);
    return {};
  }
};

/**
 * 獲取當前用戶名（帳號）
 * 優先順序：account > name > user_id > 'System'
 * 與其他頁面（如 WorkflowListPage）保持一致
 * @returns {string} 用戶帳號名
 */
export const getCurrentUsername = () => {
  try {
    const userInfo = getUserInfo();
    return userInfo.account || userInfo.name || userInfo.user_id || 'System';
  } catch (error) {
    console.error('獲取用戶名失敗:', error);
    return 'System';
  }
};
